import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  header: {
    marginBottom: 24,
  },
});
